import { Ellipse } from 'react-konva'
import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { commonShapeProps, ShapeInteraction } from './shapeInteraction'

type Props = {
  shape: Extract<VisualShape, { type: 'circle' }>
  width: number
  height: number
  interaction?: ShapeInteraction
}

const EllipseShape = ({ shape, width, height, interaction }: Props) => {
  const centerX = shape.x * width
  const centerY = shape.y * height
  const radiusX = (shape.radius_x ?? shape.radius ?? 0.08) * width
  const radiusY = (shape.radius_y ?? shape.radius ?? 0.08) * width

  return (
    <Ellipse
      ref={interaction?.nodeRef}
      x={centerX}
      y={centerY}
      radiusX={radiusX}
      radiusY={radiusY}
      rotation={shape.rotation ?? 0}
      fill={shape.fill_rgb}
      {...commonShapeProps(shape)}
      draggable={interaction?.draggable ?? false}
      listening={interaction !== undefined}
      onMouseEnter={interaction?.onMouseEnter}
      onMouseLeave={interaction?.onMouseLeave}
      onMouseDown={interaction?.onMouseDown}
      onTap={interaction?.onTap}
      onDragStart={interaction?.onDragStart}
      onDragMove={interaction?.onDragMove}
      onDragEnd={interaction?.onDragEnd}
    />
  )
}

export default EllipseShape
